import React, { useRef, useState, useEffect } from 'react'
import RequiredStar from 'srcReact/components/common2/RequiredStar'
import Button from 'srcReact/components/common2/Button'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'
import LocationTextBox from 'srcReact/components/common2/LocationTextBox'
import { createUpdateGroupActions } from 'srcReact/GroupPage'

const Location = ({
  show,
  hideNextButton,
  nextSectionVisible,
  containerCss,
  innerContainerCss,
  infoCss,
  titleCss,
  verticalLineCss,
  buttonWrapperCss,
  editMode = false
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const containerRef = useRef(null)
  const [locationRef, setLocationRef] = useState(null)
  useEffect(() => {
    if (!editMode) {
      containerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [show])
  const [focusedMode, setFocusedMode] = useState(false)

  const {
    selectedWorkplace,
    location: globalLocation,
    editSuccess,
    loading,
    groupInfo
  } = useSelector((state) => state.createUpdateGroup)
  const [infoForEditReceived, setInfoForEditReceived] = useState(false)

  const [groupLocation, setGroupLocation] = useState({
    value: globalLocation ? globalLocation.value : '',
    placeholder: t('workplace.create.placeholder_location'),
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    setGroupLocation({ ...groupLocation, value: '', hasError: false, errorMessage: '' })
  }, [])

  useEffect(() => {
    if (editMode && editSuccess && focusedMode) {
      setFocusedMode(false)
      dispatch(createUpdateGroupActions.setLocation(groupLocation))
    }
  }, [editSuccess])

  useEffect(() => {
    if (selectedWorkplace) {
      setGroupLocation({
        ...groupLocation,
        value: selectedWorkplace.location
      })
      dispatch(createUpdateGroupActions.setLocation(selectedWorkplace.location))
    }
  }, [selectedWorkplace])

  useEffect(() => {
    if (editMode && groupInfo && !infoForEditReceived) {
      setInfoForEditReceived(true)
      setGroupLocation({
        ...groupLocation,
        value: groupInfo ? groupInfo.location : ''
      })
    }
  }, [editMode, groupInfo])

  const handleNext = () => {
    dispatch(createUpdateGroupActions.setLocation(groupLocation))
    dispatch(createUpdateGroupActions.showPrivacySetting())
  }

  const handleSelectLocationBlur = (selectedLocation) => {
    if (!selectedLocation) {
      setGroupLocation({
        ...groupLocation,
        value: selectedLocation,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.location`) })
      })
    }
  }

  const handleSelectLocation = (selectedLocation) => {
    setFocusedMode(true)
    setGroupLocation({
      ...groupLocation,
      value: selectedLocation,
      hasError: false,
      errorMessage: ''
    })
  }

  const handleClear = () => {
    setGroupLocation({
      ...groupLocation,
      value: null,
      hasError: true,
      errorMessage: t('error.required', { field: t(`formlabel.location`) })
    })
  }
  const jumpToNextAfterUpdate = () => {
    if (groupLocation.value) {
      const nextContainer = document.querySelector('#privacySettingContainer')
      nextContainer.scrollIntoView(true, { behavior: 'smooth' })
      dispatch(createUpdateGroupActions.setLocation(groupLocation))
    }
  }

  const handleSave = () => {
    if (groupLocation && groupLocation.value) {
      dispatch(createUpdateGroupActions.editGroup(groupInfo.id, { location: groupLocation.value }))
    }
  }

  const handleCancel = () => {
    setFocusedMode(false)
    setGroupLocation({
      value: globalLocation ? globalLocation.value : '',
      hasError: false,
      errorMessage: '',
      isRequired: true
    })
  }

  return (
    <div
      id='locationContainer'
      ref={containerRef}
      className={`${containerCss} ${!nextSectionVisible && !editMode && styles.container} ${
        show ? styles.show : styles.hide
      }`}>
      <div class={verticalLineCss} />
      {!editMode && <p className={infoCss}>{t('group.createGroup.location.title')}</p>}
      <div className={innerContainerCss}>
        <div className={`${styles.controlWrapper} ${styles.controlWrapperLocation}`}>
          <label className={titleCss} htmlFor='name'>
            {editMode ? t('group.editGroup.groupLocation') : t('group.createGroup.location.title2')}
            {groupLocation.isRequired && <RequiredStar bold={true} />}
          </label>

          <LocationTextBox
            value={groupLocation}
            ariaLabel={t('group.createGroup.location.title2')}
            placeholder={groupLocation.placeholder}
            locationContainerCSS={`${styles.location}`}
            setRef={setLocationRef}
            handleSelectLocation={handleSelectLocation}
            handleSelectLocationBlur={handleSelectLocationBlur}
            handleClear={handleClear}
            menuPortalTarget={true}
          />
          {groupLocation.hasError && (
            <div role='alert' className={styles.formError}>
              {groupLocation.errorMessage}
            </div>
          )}
        </div>

        {editMode ? (
          focusedMode ? (
            <div className={buttonWrapperCss}>
              <React.Fragment>
                <Button style='tertiary' type='button' handleClick={handleCancel} text={t('global.cancel')} />
                <Button
                  type='button'
                  handleClick={handleSave}
                  text={loading ? <Spinner isWhite={true} /> : t('global.save')}
                />
              </React.Fragment>
            </div>
          ) : null
        ) : !hideNextButton ? (
          <div className={buttonWrapperCss}>
            <Button
              disabled={groupLocation && groupLocation.value === null}
              type='button'
              handleClick={nextSectionVisible ? jumpToNextAfterUpdate : handleNext}
              text={nextSectionVisible ? t('group.createGroup.btnNext') : t('group.createGroup.btnNext')}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}
export default Location
